import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  href: "https://discord.gg/ppZ85NHeKX",
  target: "_blank",
  style: {"display":"inline-block","background-color":"#5865f2","color":"#fff","padding":"4px 8px","border-radius":"100vh","text-decoration":"none","font-family":"Arial, sans-serif","font-size":"13px"}
}
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_footer = _resolveComponent("v-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_v_container, { class: "v-col-xl-8" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, null, {
                      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                        _createTextVNode("IIDX Viewer へようこそ", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                        _createTextVNode("初めての方は以下のボタンから新規登録を行ってください", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  "prepend-icon": "mdi-login-variant",
                  size: "large",
                  block: "",
                  variant: "tonal",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('login')))
                }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode(" ログイン / 新規登録 ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512), [
      [_vShow, !_ctx.$store.state.auth.user]
    ]),
    _withDirectives(_createVNode(_component_v_container, { class: "v-col-xl-8" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, null, {
                      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                        _createTextVNode("IIDX Viewer へようこそ", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _cache[6] || (_cache[6] = _createTextVNode(" 今日はIIDXをプレーしましたか？プレーのあとは ", -1)),
                        _createVNode(_component_v_btn, {
                          variant: "tonal",
                          rounded: "lg",
                          class: "h-auto",
                          to: "/import"
                        }, {
                          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createTextVNode(" インポート ", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[7] || (_cache[7] = _createTextVNode(" を行ってプレーを振り返りましょう。 ", -1))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512), [
      [_vShow, _ctx.$store.state.auth.user]
    ]),
    _createVNode(_component_v_container, { class: "v-col-xl-8" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, null, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createElementVNode("a", {
                  href: "https://twitter.com/IIDX_Viewer?ref_src=twsrc%5Etfw",
                  class: "twitter-follow-button",
                  "data-size": "large",
                  "data-show-count": "false"
                }, " Follow @IIDX_Viewer ", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { class: "py-0" }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createElementVNode("a", {
                  class: "twitter-timeline noscrollbar",
                  "data-lang": "ja",
                  "data-dnt": "true",
                  "data-tweet-limit": "5",
                  "data-chrome": "noscrollbar",
                  href: "https://twitter.com/IIDX_Viewer?ref_src=twsrc%5Etfw"
                }, " Tweets by IIDX_Viewer ", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, null, {
              default: _withCtx(() => [
                _createElementVNode("a", _hoisted_1, [
                  _createElementVNode("img", {
                    src: require('../assets/discord.svg'),
                    alt: "Discord",
                    style: {"vertical-align":"text-bottom","margin-right":"4px","height":"13px"}
                  }, null, 8, _hoisted_2),
                  _cache[10] || (_cache[10] = _createTextVNode(" IIDX Viewer 運営コミュニティ に参加 ", -1))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_footer, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, { class: "v-col-xl-8" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              justify: "center",
              "no-gutters": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  class: "mx-2",
                  to: "/terms"
                }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createTextVNode(" 利用規約 ", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  class: "mx-2",
                  to: "/privacy-policy"
                }, {
                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                    _createTextVNode(" プライバシーポリシー ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { justify: "center" }, {
              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                _createElementVNode("small", null, "© 2023 IIDX Viewer ", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}